import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'discussions'
  },
  {
    path: 'discussions',
    loadComponent: () => import('./features/discussions/open-discussions.page').then((m) => m.OpenDiscussionsPageComponent)
  },
  {
    path: 'feelings',
    loadComponent: () => import('./features/feelings/feelings.page').then((m) => m.FeelingsPageComponent)
  },
  {
    path: 'goals',
    loadComponent: () => import('./features/goals/goals.page').then((m) => m.GoalsPageComponent)
  },
  {
    path: 'budgeting',
    loadComponent: () => import('./features/budgeting/budgeting.page').then((m) => m.BudgetingPageComponent)
  },
  {
    path: 'recipes/ingredients',
    loadComponent: () =>
      import('./features/recipes/ingredients.page').then((m) => m.IngredientsPageComponent)
  },
  {
    path: 'recipes/new',
    loadComponent: () =>
      import('./features/recipes/recipe-create.page').then((m) => m.RecipeCreatePageComponent)
  },
  {
    path: 'recipes/plan',
    loadComponent: () => import('./features/recipes/recipe-planner.page').then((m) => m.RecipePlannerPageComponent)
  },
  {
    path: 'recipes',
    loadComponent: () => import('./features/recipes/recipes.page').then((m) => m.RecipesPageComponent)
  },
  {
    path: 'tasks/:id',
    loadComponent: () => import('./features/tasks/task-detail.page').then((m) => m.TaskDetailPageComponent)
  },
  {
    path: 'tasks',
    loadComponent: () => import('./features/tasks/tasks.page').then((m) => m.TasksPageComponent)
  },
  {
    path: 'thankful',
    loadComponent: () => import('./features/appreciations/appreciations.page').then((m) => m.AppreciationsPageComponent)
  },
  {
    path: 'avac-submission',
    loadComponent: () =>
      import('./features/avac-submissions/avac-submissions.page').then((m) => m.AvacSubmissionsPageComponent)
  },
  {
    path: 'sleep-tracker',
    loadComponent: () =>
      import('./features/sleep-tracker/sleep-tracker.page').then((m) => m.SleepTrackerPageComponent)
  },
  {
    path: 'themetest',
    loadComponent: () => import('./features/theme-test/theme-test.page').then((m) => m.ThemeTestPageComponent)
  },
  {
    path: '**',
    redirectTo: 'discussions'
  }
];
